<script>
  import { onDestroy } from "svelte";
  import IntersectionObserver from "svelte-intersection-observer";
  import { lang } from "../lib/stores";
  let element;
  let selectedLang;

  const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);

  const switchLang = () => {
    console.log(selectedLang);
    if (selectedLang === 'it') {
      lang.update(() => 'en');
    } else {
      lang.update(() => 'it');
    }
  };

  const pause = () => {
    element.pause();
  };

  const play = () => {
    element.play();
  };

  const observerCallback = (e) => {
    if (e.detail.isIntersecting) {
      play();
    } else {
      pause();
    }
  };
</script>

<section class="intro">
  <div class="intro__video">
    <IntersectionObserver {element} on:observe={observerCallback}>
      <video
        bind:this={element}
        poster="/assets/img/poster.webp"
        muted="true"
        loop="true"
        preload="auto"
        playsinline
        autoplay="true"
        class="clip"
      >
        <source src="/assets/video/intro.webm" type="video/webm" />
        <track kind="captions" />
      </video>
    </IntersectionObserver>
  </div>
  <div class="intro__title">
      <h1>
        {#if selectedLang === 'it'}
          Lui è<br />
          <span>Ghali</span>
        {:else}
          This is<br />
          <span>Ghali</span>
        {/if}
      </h1>
  </div>
  <div class="intro__text">
    <h1>
      {#if selectedLang === 'it'}
        È uno dei musicisti più amati in Italia.
      {:else}
        He is one of the most beloved musicians in Italy.
      {/if}
    </h1>
  </div>
  <div class="intro__text">
    <h2>
      {#if selectedLang === 'it'}
        Si tratta inoltre dell'artista vivente più famoso tra quelli cresciuti a
        Baggio, vincitore di 58 dischi di platino e 18 dischi d'oro.
      {:else}
        He is also the most famous living artist among those who grew up in Baggio, winner of 58 platinum records and 18 gold records.
      {/if}
    </h2>
  </div>
  <div class="intro__text">
    <h2>
      {#if selectedLang === 'it'}
        Per questi motivi, e perché ci sta simpatico, abbiamo deciso di provare ad
        analizzare i testi delle canzoni contenute nei suoi primi tre album:
        “Album”, “Lunga Vita a Sto” e “DNA”.
      {:else}
        For these reasons, and because we like him, we decided to try to analyze the lyrics of the songs contained in his first three albums: “Album”, “Lunga Vita a Sto” and “DNA”.
      {/if}
    </h2>
  </div>
  <div class="intro__welcome">
    <div>
      {#if selectedLang === 'it'}
        <h2>Benvenuti su</h2>
        <h1>Tutte le parole di Ghali</h1>
      {:else}
        <h2>Welcome to</h2>
        <h1>All the Words of Ghali</h1>
      {/if}
    </div>
  </div>
  <button on:click={switchLang} class="switchLangButton">{#if selectedLang === 'it'}🇬🇧{:else}🇮🇹{/if}</button>
</section>

<style>
  .intro {
    display: block;
    height: auto;
    position: relative;
    width: 100%;
  }

  .intro__video {
    background: var(--accent-2) url(/assets/img/poster.webp) center center
      no-repeat;
    background-size: cover;
    display: block;
    height: 100vh;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  .intro__video .clip {
    height: 100vh;
    object-fit: cover;
    width: 100%;
    z-index: 1;
  }

  .intro__video::after {
    animation-iteration-count: infinite;
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: bounce;
    bottom: 10vh;
    color: var(--background);
    content: "↓";
    display: block;
    font-family: var(--title-font-family);
    font-size: 3rem;
    font-weight: var(--title-font-weight);
    height: 60px;
    left: 50%;
    position: absolute;
    text-align: center;
    transform: translate3d(-50%, 0, 0);
    width: 60px;
    z-index: 2;
  }

  .intro__welcome,
  .intro__text,
  .intro__title {
    align-content: center;
    align-items: center;
    display: flex;
    height: 100vh;
    justify-content: center;
    margin: 0;
    scroll-snap-type: y proximity;
    text-align: center;
    width: 100%;
    z-index: 3;
  }

  .intro__title {
    margin-top: -100vh;
  }

  .intro__welcome h1,
  .intro__text h1,
  .intro__title h1 {
    color: var(--background);
    font-size: 2rem;
    line-height: 1;
    max-width: 80vw;
  }

  .intro__title h1 {
    line-height: 0.9;
  }

  .intro__title h1 span {
    font-size: 3rem;
  }

  .intro__text h2 {
    color: var(--background);
    /* font-family: var(--text-font-family); */
    font-size: 1rem;
    max-width: 90vw;
    text-shadow:
      0 0 0.5rem var(--foreground),
      0 0 1rem var(--foreground);
  }

  .intro__welcome {
    background-color: var(--accent-3);
    background-image: url(/assets/img/portrait.webp);
    background-position: bottom left;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .intro__welcome {
    align-items: flex-start;
  }

  .intro__welcome > div {
    padding: 20vh 0;
  }

  @media screen and (max-width: 768px) {
    .intro__title h1 {
      font-size: 3.6rem;
      line-height: 0.9;
    }
    .intro__title h1 span {
      font-size: 4rem;
    }
    .intro__text h2 {
      text-shadow: 0 0 5px black;
    }
  }

  @media screen and (min-width: 768px) {
    .intro__welcome h1,
    .intro__text h1,
    .intro__title h1 {
      font-size: 3rem;
    }

    .intro__title h1 span {
      font-size: 5rem;
    }

    .intro__welcome h2,
    .intro__text h2 {
      font-size: 2rem;
    }
  }

  @media screen and (min-width: 1024px) {
    .intro__welcome h1,
    .intro__text h1,
    .intro__title h1 {
      font-size: 3.5rem;
    }

    .intro__title h1 span {
      font-size: 5.5rem;
    }

    .intro__welcome h2,
    .intro__text h2 {
      font-size: 2.6rem;
    }

    .intro__text h2 {
      max-width: 75vh;
    }

    .intro__welcome {
      align-items: flex-end;
    }
  }

  @media screen and (min-width: 1260px) {
    .intro__welcome h1,
    .intro__text h1,
    .intro__title h1 {
      font-size: 4.6rem;
    }

    .intro__title h1 span {
      font-size: 6.5rem;
    }

    .intro__welcome h2,
    .intro__text h2 {
      font-size: 2.8rem;
    }
  }

  .switchLangButton {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 40px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    position: fixed;
    right: 0;
    top: 0;
  }
</style>
